import React, { Component, Fragment } from 'react';
import './App.css';
import { message, Form, Row, Col, Input, Button ,Spin} from 'antd';
import "antd/dist/antd.css";
import $ from 'jquery'
import echarts from 'echarts';

var reg = /([a-zA-Z]+)?([a-zA-Z]+.*\;\s([a-zA-Z0-9]+)?)/;
var newNav = navigator.appVersion.match(reg);
var ua = navigator.userAgent;

class PQMapp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scolldis: 0,
      requestflag: false,
      clientHeight:0,
    }
    this.getBase64Image = this.getBase64Image.bind(this)
  }

  handleScrollTop() {
    window.scrollTo(0, 0);
  }
  componentDidMount() {
    var clientHeight = document.documentElement.clientHeight
    this.setState({
      clientHeight
    })
    var flag = false;
    if (newNav) {
      var nav = newNav[0];
      var navArr = nav.split(/(\s)|((\s\d\.\d)?\;)/);
      for (var i = 0, len = navArr.length; i < len; i++) {
        if (navArr[i] == 'Android' || navArr[i] == 'iPhone' || navArr[i] == 'iPad' || navArr[i] == 'MeeGo' || navArr[i] == 'NokiaN9' || navArr[i] == 'NOKIA') {
          flag = true;
          break;
        }
      }
    }

    // if (flag) {
    //   console.log('我用了手机');
    //   if (!window.name) {
    //     window.name = 'test';
    //     window.location.reload();
    //   }
    //   flag = false
    // } else {
    //   console.log('我用了pc端');
    // }

    var _this = this
    $(document).ready(function () {
      _this.getBase64Image('./images/1.png', 'boilerwebtitlebg1')
      _this.getBase64Image('./images/6.png', 'boilerwebtitlebg6')
      $(window).scroll(function () {
        var scolldis = document.documentElement.scrollTop || document.body.scrollTop
        // console.log(scolldis)
        _this.setState({
          scolldis: scolldis
        })
      });
    });

    var option = {
      tooltip: {
        trigger: 'item',
        formatter: "{a} <br/>{b} : {c}家 ({d}%)"
      },
      color: ['#2ea7e0', '#f0cc50', '#31c7f2', '#0b51d1'],
      legend: {
        // orient: 'vertical',
        left: 0,
        top: 70,
        data: ["院校", "工程公司", "锅炉制造", "科研机构"],
      },
      series: [
        {
          name: '授权用户',
          type: 'pie',
          radius: '55%',
          center: ['50%', '60%'],
          data: [
            {
              value: 20, name: '院校',
            },
            { value: 20, name: '工程公司', },
            { value: 500, name: '锅炉制造', },
            { value: 20, name: '科研机构', }
          ],
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };
    var myChart = echarts.init(document.getElementById('frameechart'));
    // 绘制图表
    myChart.setOption(option);
  }

  

  handleSubmit = e => {
    e.preventDefault();
    var _this = this
    this.setState({
      requestflag:true
    },function(){
      this.props.form.validateFields((err, values) => {
        // console.log(err, values)
        if (!err) {
          values.Source = "性能计算软件"
          $.ajax({
            type: "post",
            url: "Booking.aspx",
            data: values,
            success: function (res) {
              console.log(res)
              if (res.indexOf("成功")>-1) {
                message.success('留言成功！')
                _this.setState({
                  requestflag:false
                })
              }
            },
            error: function (err) {
              console.log(err)
            }
          })
        }
      })
    })
  }

  getBase64Image(url, key) {
    // var callbackfunc = callback
    //console.log(url)
    //通过构造函数来创建的 img 实例，在赋予src 值后就会立刻下载图片，相比 createElement() 创建 <img> 省去了 append()，也就避免了文档冗余和污染
    var Img = new Image();
    var dataurl = "";
    Img.src = require(`${url}`);
    //console.log(Img)
    Img.onload = function () { //要先确保图片完整获取到，这是个异步事件
      //console.log(Img)
      var canvas = document.createElement("canvas"), //创建canvas元素
        width = Img.width, //确保canvas的尺寸和图片一样
        height = Img.height;
      canvas.width = width;
      canvas.height = height;
      canvas.getContext("2d").drawImage(Img, 0, 0, width, height);
      //console.log(canvas)
      dataurl = canvas.toDataURL('image/png');
      //console.log(dataurl)
      document.getElementById(key).src = dataurl
      return dataurl;
      // callbackfunc ? callbackfunc(dataURL) : null; //调用回调函数
    };
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="boilerweb">
      <Spin tip="Loading..." spinning={this.state.requestflag} style={{ width: "100%", height: this.state.clientHeight+'px' }}>
      </Spin>
        <div className="backtop" style={{ display: this.state.scolldis < 10 ? "none" : "block" }} onClick={this.handleScrollTop.bind(this)}>
          <img src={require('./images/back.png')} alt="" />
        </div>
        <div className="contactQQ">
          <a href="http://wpa.qq.com/msgrd?v=3&uin=772470192&site=qq&menu=yes"><img src={require('./images/ll04.png')} alt="" /></a>
        </div>
        <div className="boilerwebtitle">
          <img src={require('./images/1fu.jpg')} id="boilerwebtitlebg1" alt="" />
          <a href="http://www.boilersoftware.com/"><img src={require('./images/logo.png')} alt="" /></a>
          <div className="boilerwebtitletop">
            <h2 className="name"><span></span>锅 炉 性 能 设 计 计 算</h2>
            <p className="nameen">Boiler Performance Design Calculation</p>
            {/* <p className="nameen">B o i l e r &nbsp; P e r f o r m a n c e &nbsp; D e s i g n &nbsp; C a l c u l a t i o n</p> */}
          </div>
          <div className="boilerwebtitlebot">
            <p className="namecon">伯勒工业锅炉设计计算软件 &nbsp; Bole-Industry Boiler Design Calculation Software</p>
            <p className="namecon">伯勒锅炉性能设计计算软件&nbsp;  Bole-Boiler Performance Design Software</p>
          </div>
        </div>

        <div className="boilerproperty">
          <h2 className="sametitle">软<span>件定</span>义</h2>
          <ul>
            <li className="havebg">
              <h2 className="title">锅炉性能设计计算软件</h2>
              <div className="con">
                Bole-Boiler Performance Design Software <br />
                ( 简称  B-BPDs )
              </div>
            </li>
            <li>
              <p>B-BPDs专门为任意复杂的锅炉、热力电站（系统）设计提供支持，该软件提供大量的模拟燃料、传热、汽水等计算组件以及各类控制元件，通过烟气侧、汽水侧、空气侧的连接线来定义烟气、工质的流动，可以让用户快速地、图示地构造一个工程计算项目。工程计算项目可以是一台锅炉、或者一个热力电站、或者一台换热器、或者一台热风炉等。</p>
            </li>
          </ul>
          <ul className="secondul">
            <li>
              <p>B-BDCs是为工业锅炉、余热锅炉相关的制造、科研、工程、院校行业单位等定制开发的工程计算软件，软件涵盖了锅炉设计的常规计算功能。软件具有通用性、准确性、先进性，以及具有符合工程师习惯、简单易用等显著特点。</p>
            </li>
            <li className="havebg">
              <h2 className="title">工业锅炉设计计算软件</h2>
              <div className="con">
                Bole-Industry Boiler Design Calculation Software<br />
                ( 简称  B-BDCs )
              </div>
            </li>
          </ul>
        </div>

        <div className="softwarefunc">
          <h2 className="sametitle">软<span>件功</span>能</h2>
          <table>
            <tbody>
              <tr>
                <th colSpan="2">功能模块</th>
                <th>B-BDCs</th>
                <th>B-BPDs</th>
              </tr>
              <tr>
                <td rowSpan="3" className="rowspan3">热平衡计算</td>
                <td>锅炉</td>
                <td>√</td>
                <td>√</td>
              </tr>
              <tr>
                <td>热力电站</td>
                <td></td>
                <td>√</td>
              </tr>
              <tr>
                <td>复杂热力系统</td>
                <td></td>
                <td>√</td>
              </tr>

              <tr>
                <td rowSpan="3" className="rowspan3">燃烧计算</td>
                <td>燃料消耗量计算</td>
                <td>√</td>
                <td>√</td>
              </tr>
              <tr>
                <td>多燃料混合计算</td>
                <td>√</td>
                <td>√</td>
              </tr>
              <tr>
                <td>补燃计算</td>
                <td></td>
                <td>√</td>
              </tr>


              <tr>
                <td colSpan="2">热力计算</td>
                <td>√</td>
                <td>√</td>
              </tr>

              <tr>
                <td rowSpan="2" className="rowspan3">
                  再循环计算
                </td>
                <td>烟气再循环</td>
                <td></td>
                <td>√</td>
              </tr>
              <tr>
                <td>汽水再循环</td>
                <td></td>
                <td>√</td>
              </tr>

              <tr>
                <td rowSpan="2" className="rowspan3">
                  强度计算
                </td>
                <td>水管锅炉受压元件强度计算</td>
                <td>√</td>
                <td></td>
              </tr>
              <tr>
                <td>锅壳锅炉受压元件强度计算</td>
                <td>√</td>
                <td></td>
              </tr>

              <tr>
                <td colSpan="2">烟风阻力计算</td>
                <td>√</td>
                <td>√</td>
              </tr>

              <tr>
                <td rowSpan="3" className="rowspan3">
                  水循环计算
                </td>
                <td>自然循环</td>
                <td>√</td>
                <td>√</td>
              </tr>
              <tr>
                <td>强制循环</td>
                <td>√</td>
                <td>√</td>
              </tr>
              <tr>
                <td>混合循环</td>
                <td></td>
                <td>√</td>
              </tr>

              <tr>
                <td colSpan="2">汽水阻力计算</td>
                <td></td>
                <td>√</td>
              </tr>
              <tr>
                <td colSpan="2">金属管壁温计算</td>
                <td>√</td>
                <td>√</td>
              </tr>
              <tr>
                <td colSpan="2">安全阀排放量计算</td>
                <td>√</td>
                <td></td>
              </tr>
              <tr>
                <td colSpan="2">减温器计算</td>
                <td>√</td>
                <td>√</td>
              </tr>
              <tr>
                <td colSpan="2">导热油蒸汽发生器计算</td>
                <td>√</td>
                <td></td>
              </tr>


              <tr>
                <td rowSpan="3" className="rowspan3">
                  热力部件计算
                </td>
                <td>过热器计算</td>
                <td></td>
                <td>√</td>
              </tr>
              <tr>
                <td>省煤器计算</td>
                <td>√</td>
                <td>√</td>
              </tr>
              <tr>
                <td>空预器计算</td>
                <td>√</td>
                <td>√</td>
              </tr>

              <tr>
                <td colSpan="2">炉墙保温计算</td>
                <td>√</td>
                <td></td>
              </tr>
              <tr>
                <td colSpan="2">酸露点、水露点计算</td>
                <td>√</td>
                <td></td>
              </tr>
              <tr>
                <td colSpan="2">有机热载体液膜温度计算</td>
                <td>√</td>
                <td></td>
              </tr>
              <tr>
                <td colSpan="2">物性查询、单位转化工具</td>
                <td>√</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* 应用场景 */}
        <div className="applyplace">
          <h2 className="sametitle">应<span>用场</span>景</h2>
          <ul className="applyplacecon">
            <li>
              <img src={require('./images/3.png')}></img>
              <span>B-BDCs</span>
            </li>
            <li>
              <img src={require('./images/4.png')}></img>
              <span>B-BPDs</span>
            </li>
          </ul>
        </div>
        {/* 软件价值 */}
        <div className="softwarevalue">
          <img src={require('./images/6.jpg')} alt="" id="boilerwebtitlebg6"></img>
          <h2 className="valuetitle sametitle">软<span>件价</span>值</h2>
          <ul className="softwarevaluecon">
            <li>
              <h2>1</h2>
              <span>软件应用为方案设计计算提供了极大的方便、快速找寻最优方案。</span>
            </li>
            <li>
              <h2>2</h2>
              <span>经过众多案例应用验证，保证产品性能安全运行。</span>
            </li>
            <li>
              <h2>3</h2>
              <span>企业核心知识得到积累及沉淀（污染系数、利用系数等参数），建立大量的案例库。</span>
            </li>
            <li>
              <h2>4</h2>
              <span>软件的应用提高设计人员效率，市场快速响应能力得到显著增强。</span>
            </li>
          </ul>
        </div>
        {/* 授权用户 */}
        <div className="havelimituser">
          <h2 className="sametitle">授<span>权用</span>户</h2>
          <div className="havelimitusercon">
            <div id="frameechart">

            </div>
            <div className="content">
              注册企业客户600多家、客户遍布于国内主要的锅炉设备制造商，以及部分院校、特检院、研究所、设计院、工程公司、科技公司、销售服务公司等。
            </div>
          </div>
        </div>
        <div className="contactus">
          <h2 className="sameh2title">联系我们</h2>
          <Form className="form1" onSubmit={this.handleSubmit.bind(this)} layout="vertical"
          // style={{ height: (this.state.clientHeight - 40 - 80) / 3 - 50 + 'px' }}
          >
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="姓名">
                  {getFieldDecorator('Name', {
                    rules: [{ required: true, message: '请输入姓名' }],
                  })(
                    <Input />
                  )}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="邮箱">
                  {getFieldDecorator('Email', {
                    rules: [{ required: true, message: '请输入邮箱' },
                    {
                      message: '邮箱格式不正确！',
                      pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
                    }],
                  })(
                    <Input />
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="电话">
                  {getFieldDecorator('Phone', {
                    rules: [{ required: true, message: '请输入电话' },
                    {
                      message: '电话格式不正确！',
                      pattern: /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}|([\(（]?0[0-9]{2,3}[）\)]?[-]?)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/
                    }],
                  })(
                    <Input />
                  )}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="公司">
                  {getFieldDecorator('Company', {
                    rules: [{ required: true, message: '请输入公司' },],
                  })(
                    <Input />
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12} className="formbtn">
                <Form.Item>
                  <Button htmlType="submit" onClick={this.handleSubmit.bind(this)} type="primary">
                      提交留言
                    </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>

        </div>
        <div className="boilerwebbottom">
          <div className="boilerwebbottomup">
            <div className="boilerwebbottomone">
              <div className="boilerwebbottomonel">
                <h2>杭州伯勒计算机技术有限公司</h2>
                <p>Hangzhou Bole Computer Technical Co.Ltd</p>
              </div>
              <div className="boilerwebbottomoner">
                <img src={require('./images/二维码1.png')} alt="" />
                <img src={require('./images/二维码2.png')} alt="" />
              </div>
            </div>

            <div className="boilerwebbottomtwo">
              <div className="left">
                <span>电话：0571-85260997</span>
                <span>传真：0571-85260995</span>
                <span>邮箱：boilerjs@vip.163.com</span>
              </div>
              <span className="right">地址：浙江省杭州市江干区 环站北路6号 时间国际2幢401~409室</span>
            </div>
          </div>
          <div className="banquan">
            版权所有 © 杭州伯勒计算机技术有限公司 Copyright 2008 All Rights Reservd <a href="http://www.beian.miit.gov.cn"  target="_blank"  className="beianhao">浙ICP备09026386号-1</a>
        </div>
        </div>
      </div>
    );
  }
}

const PQMappa = Form.create()(PQMapp);
export default PQMappa;
